/* eslint-disable linebreak-style */

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { get, set } from 'lodash';
import { Typography, Table, Tooltip, Button, Input, DatePicker, Row, Col, Form, Select, Image, Avatar, Badge, Card, Space, Tag } from 'antd';
import { FilePdfOutlined, EditOutlined, ShareAltOutlined, ArrowLeftOutlined, RightCircleTwoTone, DownCircleTwoTone } from '@ant-design/icons'
import GenerateLicenseForm from '../components/LicenseForm.js';
import moment from 'moment';
import ShareLicenseForm from '../components/ShareLicenseForm.js';
import { fetchGroupLicenseList } from '../redux/LicenseManager/action.js';
import history from '../services/history.js';
import DownloadForm from '../components/DownloadForm.js';
import { authenticateCurrentUser } from '../services/auth.js';
import { GetDashboardList, getFilterCategoryListFromDatabse } from '../redux/LicenseManager/saga.js';

const { Option } = Select;
const { Title, Text } = Typography;

const GenerateLicense = (props) => {

    const {
        licenseData,
        isLicenseLoading,
        isUploadLicsense,
        licenseTotalCount,
        onFetchLicenseData
    } = props
    const [licenseForm] = Form.useForm()
    const [shareForm] = Form.useForm()
    const [generateLiceseVisible, setGenerateLiceseVisible] = useState(false);
    const [showShareModel, setShowShareModel] = useState(false);
    const [expiryDateSearch, setExpiryDateSearch] = useState('');
    const [paginationClear, setPaginationClear] = useState(false);
    const [editRecord, seteditRecord] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [showDownloadModel, setShowDownloadModel] = useState(false);
    const [downloadDataList, setDownloadDataList] = useState([]);
    const [uniqueIdData, setuniqueIdData] = useState([]);
    const [licenseUniqueIdList, setLicenseUniqueIdList] = useState([]);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [currentPagesize, setCurrentPagesize] = useState(10);
    const [perpetualDate, setPerpetualDate] = useState(null);
    const [selectedSearchBy, setSelectedSearchBy] = useState('')
    const statuslist = ['Identifier', 'Unique ID', 'Machine Type', 'Location', 'Customer', "Feature Type", 'Expiration Date', "Create Date"]
    const [userName, setUserName] = useState('');
    const [userGroup, setUserGroup] = useState([]);
    const [searchCriteria, setSearchCriteria] = useState({
        Unique_Id: '',
        Type_Of_Device: '',
        Board_Type: '',
        Location: '',
        Customer_Name: '',
        Feature_Type: ''
    });
   const [filterCategoryList, setFilterCategoryList] = useState({
        'projectname': []
    });
       const [selectedTypeFilter, setSelectedFilterType] = useState({});
     const [searchFilterType, setSearchFilterType] = useState({});
      const [searchType, setSearchType] = useState({});
    const [sortingKeys, setSortingKeys] = useState(null);
    const [dashboardList, setDashboardList] = useState([]);
    /** get user Access */
    useEffect(() => {
        authenticateCurrentUser()
            .then(async (data) => {
                if (data.signInUserSession.accessToken.payload["cognito:groups"]) {

                    let response = data.signInUserSession.accessToken.payload["cognito:groups"] //await getA(data.username)
                    //const userAccess = response.map(item => item?.GroupName)
                    //console.log(response)
                    //setUserName(data.username);
                    setUserGroup(response);
                }
            })
            .catch((error) => {
                console.log('error', error);
            });
    }, [history]);
    // useEffect(() => {
    //     if (showShareModel)
    //         return;
    //     var obj = {
    //         pageSize: 10,
    //         pageNumber: 1
    //     }

    //     onFetchLicenseData(obj);
    //     // console.log(licenseData)
    // }, []);


    const fetchLicenseData = async () => {
        var obj = {
            pageSize: currentPagesize,
            pageNumber: currentPageNumber,
            searchKey: searchCriteria,
            sort: sortingKeys
        }   
        await onFetchLicenseData(obj)
    }


    useEffect(() => {

        (async () => {

            if (showShareModel)
                return;
           await fetchLicenseData()
            // const dashBoardList = await GetDashboardList();
            // if (dashBoardList)
            //     setDashboardList(dashBoardList)
            //console.log('DashBoard List', dashBoardList)
        })();

        //console.log(searchText)
    }, [searchCriteria]);

    useEffect(() => {
        if (!isEdit) {
            seteditRecord('')
            licenseForm.resetFields();
        }
    }, [isEdit])

    const featureAvatarMap = {
        "Basic Function": { label: "B", Label_1: '', color: "#F3E5F5", textColor: "#6A1B9A", tooltip: "Basic Function" },
        "Solid Wire": { label: "S", Label_1: '', color: "#E3F2FD", textColor: "#1565C0", tooltip: "Solid Wire" },
        "Horizontal Tracking": { label: "H", Label_1: '', color: "#E8F5E9", textColor: "#2E7D32", tooltip: "Horizontal Tracking" },
        "Fronius PS": { label: "F",  Label_1: '', color: "#FFF3E0", textColor: "#0277BD", tooltip: "Fronius TPSi" },
        "Lincoln PS": { label: "L", Label_1: '', color: "#FFEBEE", textColor: "#C62828", tooltip: "Lincoln PS" }
    };

    const featureP625AvatarMap = {
        "Basic Function": { label: "B", Label_1: '', color: "#F3E5F5", textColor: "#6A1B9A", tooltip: "Basic Function" },
        "360 Degree Welding": { label: "360°", Label_1: '', color: "#E8EAF6", textColor: "#283593", tooltip: "360 Degree Welding" },
        "Zone to Zone Ramping": { label: "Z", Label_1: '', color: "#E8F5E9", textColor: "#2E7D32", tooltip: "Zone Ramping" },
        "Touch and Ramp": { label: "T",  Label_1: '',color: "#FCE4EC", textColor: "#880E4F", tooltip: "Touch" },
        "Fronius TPSi": { label: "F", Label_1: '', color: "#FFF3E0", textColor: "#0277BD", tooltip: "Fronius TPSi" }
    };

    const MachineAvatarMap = {
        "M500": { label: "M500", color: "#DCEDC8", textColor: "#33691E", tooltip: "M500" },
        "P625": { label: "P625", color: "#FFECB3", textColor: "#FF8F00", tooltip: "P625" }
    };
    const featurelegtatyAvatarMap = [
        "Basic Function",
        "Solid Wire",
        "Horizontal Tracking",
        "Fronius PS",
        "Lincoln PS"
    ];

    // Fixed display order for avatars (Basic, Hard/Solid Wire, Horizontal, Fronius, Lincoln)
    const FEATURE_DISPLAY_ORDER_M500 = [...featurelegtatyAvatarMap];
    const FEATURE_DISPLAY_ORDER_P625 = [
        "Basic Function",
        "360 Degree Welding",
        "Zone to Zone Ramping",
        "Touch and Ramp",
        "Fronius TPSi"
    ];

    const featureP625LengtaryAvatarMap = [
        "360 Degree Welding",
        "Zone to Zone Ramping",
        "Touch and Ramp",
        //"Fronius TPSi"
    ];
    const filtermaping = [
       
        {
            title: 'Unique Id',
            dataIndex: 'Unique_Id',
            key: 'Unique_Id',
            width: '220px',

        },
        {
            title: 'Machine Type',
            dataIndex: 'Type_Of_Device',
            key: 'Type_Of_Device',
            align: 'center',

        },
        {
            title: 'Board Type',
            dataIndex: 'Board_Type',
            key: 'Board_Type',
            align: 'center',

        },
        {
            title: 'Location',
            dataIndex: 'Location',
            key: 'Location',
        },
      
        {
            title: 'Customer Name',
            dataIndex: 'Customer_Name',
            key: 'Customer_Name',
            align: 'center',

        },
       
        {
            title: 'Feature Type',
            dataIndex: 'Feature_Type',
            key: 'Feature_Type',
            align: 'center',
            width: '160px',

        },
       

    ]
    
        const GetFilterCategroyInputFeild = (fieldName,placeHolder) => {
            return (
                <div className='searchDashboardSpares'>
                    <div className='maintenance-select1'>
                        <Select
                            className='maintenance-select1'
                            placeholder={`Select ${placeHolder}`}
                            showSearch
                            allowClear
                            mode="multiple"
                            tagRender={tagRender}
    
    
                            //loading={isUserListLoading}
                            style={{
                                height: '35px',
                                position: 'relative',
                                top: '0px',
                                width: '100%'
                                
                            }}
                            //optionFilterProp="children"
                            optionFilterProp={false}
                            onChange={(value) => handleComboboxChange(fieldName, value)}
                            // onFocus={onGetAllUsers}
                            // onDropdownVisibleChange={handleDropdownVisibleChange}
                            onSearch={(value) => handleSearchComboboxChange(fieldName, value)}
                            searchValue={searchFilterType[fieldName]}
                            //value={matrialSearchType == '' ? selectedMaterial : matrialSearchType}
                            value={selectedTypeFilter[fieldName]}
    
                        // disabled={disableTypes}
                        >
                            {Object.keys(filterCategoryList).length > 0 && filterCategoryList[fieldName] &&
                                filterCategoryList[fieldName]
                                    //.sort((a, b) => a[column.dataIndex].localeCompare(b[column.dataIndex])) // Sort by category
                                    .map((item, i) => (
                                        <Option key={i} value={item[fieldName]}> {/* Use item.category as value */}
                                            {item[fieldName]}
                                        </Option>
                                    ))
                            }
                        </Select>
                        <div className="selected-tags">
                            {selectedTypeFilter && selectedTypeFilter[fieldName]?.length == 0 && searchFilterType[fieldName] != '' &&
                                <div key={0} className='selected-tag'>
                                    {searchFilterType[fieldName]}
                                    <span
                                        className='remove-tag'
                                        onClick={() => {
    
    
                                            handleSearchComboboxChange(fieldName, '')
                                            //setSelectedMaterial(newSelectedMaterials);
                                        }}
                                    >
                                        X
                                    </span>
                                </div>
                            }
                            {searchFilterType[fieldName] === '' && selectedTypeFilter[fieldName]?.length > 0 &&selectedTypeFilter[fieldName].map((value, index) => (
                                <div key={index} className='selected-tag'>
                                    {value}
                                    <span
                                        className='remove-tag'
                                        onClick={() => {
    
                                            const newSelectedMaterials = selectedTypeFilter[fieldName].filter(item => item !== value);
                                            //handleMaterialComboboxChange(newSelectedMaterials)
                                            handleComboboxChange(fieldName, newSelectedMaterials)
                                            //setSelectedMaterial(newSelectedMaterials);
                                        }}
                                    >
                                        X
                                    </span>
                                </div>
                            ))}
    
                        </div>
                    </div>
                </div>
            )
        }


  
    const columns_Feture_type = [
        {
            title: 'Feature Type',
            dataIndex: 'Feature_Type',
            key: 'Feature_Type',
            filterSearch: true,
            render: (text) => <a style={{ paddingLeft: '0px' }}>{text}</a>,
        },
        {
            title: 'Details',
            dataIndex: 'LicenceInfo_History_data',
            key: 'LicenceInfo_History_data',
            render: (text, record) => {
                return (
                    <>



                        <Tooltip title="Details" >
                            <span className="icon-24 mr-2 cursor-pointer edit-hover"  >

                                <FilePdfOutlined onClick={() => {

                                    showdownloaddModal(record);
                                }} />

                            </span>
                            <span className="icon-24 mr-2 cursor-pointer edit-hover"  >({getlengthOfData(record)})</span>
                        </Tooltip>
                        {/* <Tooltip title="Download license file" >

                            <span className="icon-24 mr-2 cursor-pointer edit-hover"  >
                                <Button className='p-0 border-0' size='small' target='_blank'>

                                </Button>
                            </span>

                        </Tooltip> */}


                    </>
                )
            },
            align: 'center'
        },
    ];
    const getlengthOfData = (record) => {
        const item = get(record, 'LicenceInfo_History', [])

        return item ? item.length : 0
    }
    const columns_feild = [

        // {
        //     title: 'Version',
        //     dataIndex: 'version',
        //     key: 'version',
        //     filterSearch: true,
        //     render: (text) => <a style={{ paddingLeft: '2px' }}>{text}</a>,
        // },

        {
            title: 'Feature Type',
            dataIndex: 'Feature_Type',
            key: 'Feature_Type',
            filterSearch: true,
            render: (text) => <a style={{ paddingLeft: '0px' }}>{text}</a>,
        },

        {
            title: 'User Identifier',
            dataIndex: 'License_File_Name',
            key: 'License_File_Name',
            filterSearch: true,
            width: '150px',
            sorter: (a, b) => (a.License_File_Name.localeCompare(b.License_File_Name)),
            render: (text) => <a style={{ paddingLeft: '2px' }}>{text}</a>,
        },
        {
            title: 'Customer Name',
            dataIndex: 'Customer_Name',
            key: 'Customer_Name',
            align: 'center',
            render: (text) => <div style={{ placeContent: 'center' }}>{text ? text : '-'}</div>,
            sorter: (a, b) => (a.Customer_Name.localeCompare(b.Customer_Name))
        },
        {
            title: 'Machine Serial Number',
            dataIndex: 'Serial_Number',
            key: 'Serial_Number',
            align: 'center',
            width: '160px',
            render: (text) => <div style={{ placeContent: 'center' }}>{text ? text : '-'}</div>,
            sorter: (a, b) => (a.Serial_Number.localeCompare(b.Serial_Number))
        },
        {
            title: 'Created Date',
            dataIndex: 'File_Creation_Date',
            key: 'File_Creation_Date',
            align: 'center',
            render: (text) => {
                return (
                    <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
                );
            },
            //sorter: (a, b) => moment(a.File_Creation_Date).valueOf() - moment(b.File_Creation_Date).valueOf()
        },
        {
            title: 'Expiration Date',
            dataIndex: 'Expiration_Date',
            key: 'Expiration_Date',
            align: 'center',
            render: (text) => {
                return (
                    <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
                );
            },
            // sorter: (a, b) => a.Expiration_Date - b.Expiration_Date,
            // sorter: (a, b) => moment(a.Expiration_Date).valueOf() - moment(b.Expiration_Date).valueOf()
        },
        {
            title: 'Edit / Download',
            dataIndex: 'File_Link',
            key: 'File_Link',
            render: (text, record) => {
                return (
                    <>
                        <Tooltip title="Update">
                            <span className="icon-18 mr-2 cursor-pointer edit-hover"
                            // style={{ cursor: 'not-allowed' }}
                            >
                                <EditOutlined style={{ fontSize: '18px' }}
                                    onClick={() => {
                                        showdownloaddModal(record);
                                    }}
                                />
                            </span>
                        </Tooltip>




                    </>
                )
            },
            align: 'center'
        },
    ];


    const showModal = (record) => {
        let editData = null;
        if (record != null) {

            const name = record.License_File_Name.split('_')
            editData = {
                uniqueId: record.Unique_Id,
                fileName: name[0],

                featureType: record.Feature_Type,
                application_type: record.Type_Of_Device,
                customerName: record.Customer_Name,
                serialNumber: record.Serial_Number,
                location: record.Location,
                board_type: record.Board_Type,
                Board_Serial_Number: record.Board_Serial_Number ?? ''
            };
            licenseForm.setFieldsValue(editData)
            setIsEdit(true)
            seteditRecord(record)
            setGenerateLiceseVisible(true)
        }
    }
    const showdownloaddModal = (record) => {

        if (record != null) {
            //   const val = get(record, 'LicenceInfo_History', []);
            setDownloadDataList(record.LicenceInfo_History);
            setShowDownloadModel(true);
        }
    }

    // const onSearchLicense = async (event) => {
    //     //console.log(event)
    //     if (event.target.value) {
    //         setSearchText(event.target.value);
    //     }
    //     else
    //         setSearchText('')
    // }

    const handleSearchInputChange = (fieldName, value) => {
        setSearchCriteria(prevSearchCriteria => ({
            ...prevSearchCriteria,
            [fieldName]: value
        }));
    }
    const handleSearchDateSelect = (fieldName, date) => {
        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
        handleSearchInputChange(fieldName, formattedDate);
    };


    // const handleSearchInputChange = (fieldName, value) => {
    //     setSearchCriteria(prevSearchCriteria => ({
    //         ...prevSearchCriteria,
    //         [fieldName]: value
    //     }));
    // }
    const handleTypeSearchInputChange = (fieldName, value) => {
        setSearchType(prevSearchCriteria => ({
            ...prevSearchCriteria,
            [fieldName]: value
        }));
    }
    const handleComboboxChange = async (fieldName, value) => {

        setSearchFilterType(prevSearchtype => ({
            ...prevSearchtype,
            [fieldName]: ''
        }));
        setSelectedFilterType(prevSelectedtype => ({
            ...prevSelectedtype,
            [fieldName]: value
        }));


        await handleTypeSearchInputChange(fieldName, value)
        await handleSearchInputChange(fieldName, value)
    };
    const tagRender = (props) => {
        return null
       
    };

    const handleSearchComboboxChange = async (category, value) => {


        {
            //await handleSearchInputChange('Material', value)
            //setSelectedMaterial([value])
            setSearchFilterType(prevSearchtype => ({
                ...prevSearchtype,
                [category]: value
            }));
            //await handleTypeSearchInputChange('Material', value)
            await handleTypeSearchInputChange(category, value)
            await handleSearchInputChange(category, value)
            // handleSearchFilterInputChange('Material', value)
        }

    };

    const UpdateFilterCategoryList = async (fieldName, value) => {
        setFilterCategoryList(prevcategory => ({
            ...prevcategory,
            [fieldName]: value
        }));
    }

    const UpdateFilterCategory = async () => {
        const batchSize = 5; // Number of concurrent requests
        for (let i = 0; i < filtermaping.length; i += batchSize) {
            const batch = filtermaping.slice(i, i + batchSize).map(async column => {
                if (column.dataIndex !== 'edit_delete') {
                    if (!selectedTypeFilter[column.dataIndex] || selectedTypeFilter[column.dataIndex]?.length === 0) {
                        const categoryList = await getCategoryList(column.dataIndex, searchType);
                        await UpdateFilterCategoryList(column.dataIndex, categoryList);
                    }
                }
            });
            await Promise.all(batch); // Wait for the batch to finish before starting the next one
        }
    };

    useEffect(() => {
        (async () => {
           // console.log(filterCategoryList)
            await UpdateFilterCategory();
        })();
    }, [searchType]);

    const getCategoryList = async (searchKeyExist, searchkey) => {
        try {
            const object = {
                header: searchKeyExist,
                searchKey: searchkey
            }
            //  console.log('Search key', object)
            //return;
            const response = await getFilterCategoryListFromDatabse(object);
         //  console.log('Search key', response,searchKeyExist)
            if (response && response.length > 0 && searchKeyExist) {

                return response.filter(item => item[searchKeyExist] !== '');
            }
            return []
        } catch (error) {
            // notification.error({
            //     message: 'Something went wrong. ' + searchKeyExist,
            // });
            return []
        }
    };
    const columns = [

        {
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', width: '100%', textAlign: 'left', paddingLeft: '30%' }}>
                        Unique ID
                    </div>
                    <div className='searchDashboardSpares'>
                        {GetFilterCategroyInputFeild('Unique_Id','Unique ID')}
                    </div>
                </div>
            ),
            dataIndex: 'Unique_Id',
            key: 'Unique_Id',
            align: 'left',
            width: '280px',
            ellipsis: true,
            // sorter: (a, b) => a.equipmentType.localeCompare(b.equipmentType),
        },
        {
            key: 'Unique_Id',
            align: 'left',
            width: '30px',
            sorter: true,
        },


        // {
        //     title: 'User Identifier',
        //     dataIndex: 'License_File_Name',
        //     key: 'License_File_Name',
        //     filterSearch: true,
        //     width: '150px',
        //     sorter: (a, b) =>  (a.License_File_Name.localeCompare(b.License_File_Name)),
        //     render: (text) => <a style={{ paddingLeft: '2px' }}>{text}</a>,
        // },
        {

            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px' }}>Machine Type</div>
                    <div className='searchDashboardSpares'>
                        {GetFilterCategroyInputFeild('Type_Of_Device','Machine Type')}
                    </div>
                </div>
            ),
            dataIndex: 'Type_Of_Device',
            key: 'Type_Of_Device',
            align: 'center',
           // width: '280px',
            //width: '10%',
            // sorter: (a, b) => a.Type_Of_Device.localeCompare(b.Type_Of_Device)
            render: (text, record) => {

                const avatarData = MachineAvatarMap[record.Type_Of_Device];
                if (!avatarData) {
                    return null;
                }


                return (

                    <Tooltip title={avatarData.tooltip} key={text}>

                        <Avatar
                            style={{
                                backgroundColor: avatarData.color, width: '100px',   // Rectangle width
                                height: '30px',   // Rectangle height
                                borderRadius: '5px',  // Rounded corners

                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '14px', // Adjust text size
                                fontWeight: 'bold',
                                color: avatarData.textColor,

                            }}
                            shape='square'

                        >
                            {avatarData.label}
                        </Avatar>

                    </Tooltip>
                )
            }

        },
        {
            key: 'Type_Of_Device',
            align: 'left',
            width: '30px',
            sorter: true,
        },
        {
            // title: 'Board Type',
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', paddingLeft: '30%' }}>Board Type</div>
                    <div className='searchDashboardSpares'>
                    {GetFilterCategroyInputFeild('Board_Type','Board Type')}
                    </div>
                </div>
            ),
            dataIndex: 'Board_Type',
            key: 'Board_Type',
            align: 'left',
            // width: '20%',

            // sorter: (a, b) => (a.Board_Type.localeCompare(b.Board_Type))
        },
        {
            key: 'Board_Type',
            align: 'left',
            width: '30px',
            sorter: true,
        },

        {
            title: 'Location',
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px' }}>Location</div>
                    <div className='searchDashboardSpares'>
                    {GetFilterCategroyInputFeild('Location','Location')}
                    </div>
                </div>
            ),
            dataIndex: 'Location',
            key: 'Location',
            align: 'parameter',
            align: 'center',
            render: (text) => <div style={{ placeContent: 'left' }}>{text ? text : '-'}</div>,
            // width: '10%',
            //sorter: (a, b) =>  (a.Customer_Name.localeCompare(b.Customer_Name))
        },
        {
            key: 'Location',
            align: 'left',
            width: '30px',
            sorter: true,
        },
        {
            //  title: 'Customer',
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px' }}>Customer</div>
                    <div className='searchDashboardSpares'>
                    {GetFilterCategroyInputFeild('Customer_Name','Customer')}
                    </div>
                </div>
            ),
            dataIndex: 'Customer_Name',
            key: 'Customer_Name',

            align: 'Center',
            render: (text) => <div style={{ placeContent: 'center' }}>{text ? text : '-'}</div>,
            //sorter: (a, b) => (a.Contractor.localeCompare(b.Contractor))
            // width: '15%',
        },
        {
            key: 'Customer_Name',
            align: 'left',
            width: '30px',
            sorter: true,
        },

        {
            title: 'Feature Type',
            title: (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ marginBottom: '4px', paddingLeft: '30%' }}>Feature Type</div>
                    <div className='searchDashboardSpares'>
                    {GetFilterCategroyInputFeild('Feature_Type','Feature Type')}
                    </div>
                </div>
            ),
            dataIndex: 'Feature_Type',
            key: 'Feature_Type',
            align: 'left',
            render: (text, record) => {
                //  console.log(record);

                // Ensure LicenceInfo_History exists and is an array
                if (!record?.LicenceInfo_data || !Array.isArray(record.LicenceInfo_data)) {
                    return null;
                }



                // Sort by fixed order: Basic, Hard Wire/Solid Wire, Horizontal, Fronius, Lincoln
                const displayOrder = record.Type_Of_Device === 'M500' ? FEATURE_DISPLAY_ORDER_M500 : FEATURE_DISPLAY_ORDER_P625;
                const sortedLicenceInfo = [...record.LicenceInfo_data].sort((a, b) => {
                    const idxA = displayOrder.indexOf(a.Feature_Type);
                    const idxB = displayOrder.indexOf(b.Feature_Type);
                    return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
                });
                return (
                    <div>
                        <Avatar.Group style={{ display: 'flex', flexWrap: 'wrap', gap: "3px", }}>
                            {sortedLicenceInfo.map((item, index) => {
                                const featureType = item.Feature_Type;
                                const avatarData = record.Type_Of_Device == 'M500' ? featureAvatarMap[featureType] : featureP625AvatarMap[featureType];

                                return (
                                    avatarData && (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'wrap', gap: '10px', }}>
                                            <Tooltip title={avatarData.tooltip} key={index}>

                                                <Avatar className="member-avatar"
                                                    // style={{ backgroundColor: avatarData.color,  }}
                                                    onClick={() => showdownloaddModal(item)}
                                                    style={{
                                                        backgroundColor: avatarData.color,
                                                        color: avatarData.textColor,
                                                        fontWeight: "bold",
                                                        marginLeft: '2px',
                                                        cursor: 'pointer'
                                                    }}

                                                >
                                                    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{avatarData.label.charAt(0)}</span>
                                                    <span style={{ fontSize: '10px', fontWeight: 'normal', marginLeft: '2px' }}>
                                                        {avatarData.Label_1}
                                                    </span>
                                                </Avatar>

                                            </Tooltip>
                                        </div>
                                    )
                                );
                            })}
                        </Avatar.Group>

                    </div>
                );
            }


        },

        {
            key: 'Feature_Type',
            align: 'left',
            width: '30px',
            sorter: true,
        },
        // {
        //     title: 'Customer Name',
        //     dataIndex: 'Customer_Name',
        //     key: 'Customer_Name',
        //     align: 'center',
        //     render: (text) => <div style={{  placeContent: 'center' }}>{text ? text : '-'}</div>,
        //     sorter: (a, b) =>  (a.Customer_Name.localeCompare(b.Customer_Name))
        // },
        // {
        //     title: 'Machine Serial Number',
        //     dataIndex: 'Serial_Number',
        //     key: 'Serial_Number',
        //     align: 'center',
        //     width: '160px',
        //     render: (text) => <div style={{ placeContent: 'center' }}>{text ? text : '-'}</div>,
        //     sorter: (a, b) =>  (a.Serial_Number.localeCompare(b.Serial_Number))
        // },
        // {
        //     title: 'Create Date',
        //     dataIndex: 'File_Creation_Date',
        //     key: 'File_Creation_Date',
        //     align: 'center',
        //     render: (text) => {
        //         return (
        //             <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
        //         );
        //     },
        //     sorter: (a, b) => moment(a.File_Creation_Date).valueOf() - moment(b.File_Creation_Date).valueOf()
        // },
        // {
        //     title: 'Expiration Date',
        //     dataIndex: 'Expiration_Date',
        //     key: 'Expiration_Date',
        //     align: 'center',
        //     render: (text) => {
        //         return (
        //             <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
        //         );
        //     },
        //     // sorter: (a, b) => a.Expiration_Date - b.Expiration_Date,
        //     sorter: (a, b) => moment(a.Expiration_Date).valueOf() - moment(b.Expiration_Date).valueOf()
        // },

        // {
        //     title: 'Edit / Download',
        //     dataIndex: 'File_Link',
        //     key: 'File_Link',
        //     render: (text, record) => {
        //         return (
        //             <>
        //                 <Tooltip title="Update">
        //                     <span className="icon-18 mr-2 cursor-pointer edit-hover"
        //                     // style={{ cursor: 'not-allowed' }}
        //                     >
        //                         <EditOutlined style={{ fontSize: '18px' }}
        //                             onClick={() => {
        //                                 showModal(record);
        //                             }}
        //                         />
        //                     </span>
        //                 </Tooltip>


        //               {
        //               get(record, 'LicenceInfo_History', []).length > 1?

        //                 <Tooltip title="Download license file" >
        //                     <span className="icon-24 mr-2 cursor-pointer edit-hover"  >

        //                         <FilePdfOutlined onClick={() => {

        //                             showdownloaddModal(record);
        //                         }} />

        //                     </span>
        //                     <span className="icon-24 mr-2 cursor-pointer edit-hover"  >({get(record, 'LicenceInfo_History', []).length})</span>
        //                 </Tooltip> :
        //                 <Tooltip title="Download license file" >

        //                     <span className="icon-24 mr-2 cursor-pointer edit-hover"  >
        //                         <Button href={get(record, 'LicenceInfo_History', [])[0].File_Link} className='p-0 border-0' size='small' target='_blank'>
        //                             <FilePdfOutlined>sella</FilePdfOutlined>
        //                         </Button>
        //                     </span>

        //                 </Tooltip>
        //     }

        //             </>
        //         )
        //     },
        //     align: 'center'
        // },

    ];


    const searchInputs = [
        { field: 'Unique_Id', placeholder: 'Search Unique Id' },
        { field: 'Type_Of_Device', placeholder: 'Search Machine Type' },
        { field: 'Board_Type', placeholder: 'Search Board Type' },
        { field: 'Location', placeholder: 'Search Location' },
        { field: 'Customer_Name', placeholder: 'Search Customer' },
        { field: 'Feature_Type', placeholder: 'Search Feature Type' },

    ];

    const updatedColumns = columns.map(column => {
        if (column.dataIndex === 'creationDate' || column.dataIndex === 'updatedDate') {
            return {
                ...column,
                title: (
                    <Space style={{ display: 'flow', alignItems: 'center', }}>
                        {column.title}
                        <div className='date-picker'>
                            <DatePicker
                                allowClear
                                style={{ height: '30px', border: 'line', }}
                                format="DD-MM-YYYY"
                                placeholder='Search'
                                onChange={date => handleSearchDateSelect(column.dataIndex, date)}
                                bordered
                            />
                        </div>
                    </Space>
                ),
            };
        } else if (column.dataIndex !== 'edit_delete' && column.dataIndex !== 'report') {
            return {
                ...column,
                title: (
                    <Space style={{ display: 'flow', alignItems: 'center', }}>
                        {column.title}
                        <div className='searchEquip'>
                            <Input
                                placeholder={searchInputs.find(input => input.field === column.dataIndex)?.placeholder}
                                value={searchCriteria[column.dataIndex]}
                                onChange={e => handleSearchInputChange(column.dataIndex, e.target.value)}
                                allowClear
                            />
                        </div>
                    </Space>



                ),
            };
        } else {
            return column;
        }
    });

    // const handleDateSelect = async (date, dateString) => {
    //     if (date)
    //         setSearchText(moment(date).format('YYYY-MM-DD'))
    //     else
    //         setSearchText('')
    // }
    // const handleCreatedDateSelect = async (date, dateString) => {
    //     if (date)
    //         setSearchText(moment(date).format('YYYY-MM-DD'))
    //     else
    //         setSearchText('')
    // }
    const handleLicenseVisibe = () => {

        setGenerateLiceseVisible(true)
    }

    const onshowShareLicenseFrom = () => {
        shareForm.resetFields();
        setuniqueIdData([])
        setLicenseUniqueIdList([])
        setShowShareModel(true)
    }
    useEffect(() => {
        if (!showShareModel) {
            setLicenseUniqueIdList([])
        }
    }, [showShareModel])
    // const columns_feild = [

    //     {
    //         title: 'Version',
    //         dataIndex: 'version',
    //         key: 'version',
    //         filterSearch: true,
    //         render: (text) => <a style={{ paddingLeft: '2px' }}>{text}</a>,
    //     },

    //     {
    //         title: 'Feature Type',
    //         dataIndex: 'Feature_Type',
    //         key: 'Feature_Type',
    //         filterSearch: true,
    //         render: (text) => <a style={{ paddingLeft: '0px' }}>{text}</a>,
    //     },
    //     {
    //         title: 'Created Date',
    //         dataIndex: 'File_Creation_Date',
    //         key: 'File_Creation_Date',
    //         align: 'center',
    //         render: (text) => {
    //             return (
    //                 <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
    //             );
    //         },
    //         //sorter: (a, b) => moment(a.File_Creation_Date).valueOf() - moment(b.File_Creation_Date).valueOf()
    //     },
    //     {
    //         title: 'Expiration Date',
    //         dataIndex: 'Expiration_Date',
    //         key: 'Expiration_Date',
    //         align: 'center',
    //         render: (text) => {
    //             return (
    //                 <div>{text ? moment(text).format('DD MMM YYYY') : '-'}</div>
    //             );
    //         },
    //         // sorter: (a, b) => a.Expiration_Date - b.Expiration_Date,
    //         // sorter: (a, b) => moment(a.Expiration_Date).valueOf() - moment(b.Expiration_Date).valueOf()
    //     },
    // ];
    const expandedRowRender = (record) => {
        // Customize the content inside the expanded row (nested group)

        return (
            record.LicenceInfo_data ?
                <div className='addTeamDetails3'>
                    <Table showHeader={true}
                        className="h-100 pipeline-table equip_table equipPaginationTable"

                        rowKey={'id'}
                        columns={columns_Feture_type} // Exclude the first two columns (Category and Subcategory)
                        dataSource={[...record.LicenceInfo_data]}
                        pagination={false}
                        rowClassName={(nestedRecord, nestedIndex) =>
                            nestedIndex % 2 === 0 ? 'even-row' : 'odd-row'
                        }
                    />
                </div>
                : null
        );
    };
    const rowClassName = (record, index) => {
        return index % 2 === 0 ? 'even-row' : 'odd-row';
    };
    const handlePerpetualDateSelect = async (date, dateString) => {
        if (date)
            setPerpetualDate(moment(date).format('YYYY-MM-DD'))
        else
            setPerpetualDate('')
    }




    const DashboardCards = () => {
        // Define colors and icons based on category
        const categoryIcons = {
            "Unique_Id": "📊",
            "M500": "🔥",
            "P625": "🔧"
        };

        const categoryColors = {
            "Unique_Id": "pink",
            "M500": "orange",
            "P625": "blue"
        };

        // Extract necessary data
        const uniqueIdCount = dashboardList.find((item) => item.Category === "Unique_Id")?.Count || 0;

        const m500AppCount = dashboardList.find((item) => item.Name === "Application Board" && item.Category === "Board_Type")?.Count || 0;
        const m500MotorCount = dashboardList.find((item) => item.Name === "Motor Board" && item.Category === "Board_Type")?.Count || 0;

        const p625BeforeCount = dashboardList.find((item) => item.Name.includes("Before Version 8.8.17"))?.Count || 0;
        const p625AfterCount = dashboardList.find((item) => item.Name.includes("Version 8.8.17 and Later"))?.Count || 0;

        const cardData = [
            { key: "Unique_Id", name: "Unique Id", count: uniqueIdCount },
            { key: "M500", name: "M500", count: m500AppCount + m500MotorCount, details: [`Application: ${m500AppCount}`, `Motor: ${m500MotorCount}`] },
            { key: "P625", name: "P625", count: p625BeforeCount + p625AfterCount, details: [`Before 8.8.17: ${p625BeforeCount}`, `After 8.8.17: ${p625AfterCount}`] }
        ];

        return (
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
                {cardData.map((item) => (
                    <Card
                        key={item.key}
                        style={{
                            width: "200px",
                            textAlign: "center",
                            boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
                            borderRadius: "5px",
                            padding: "0px",
                            height: '60px',
                            backgroundColor: "transparent"
                        }}
                    >
                        {/* <span style={{ fontSize: "12px", color: categoryColors[item.key] }}>
                        {categoryIcons[item.key]}
                    </span> */}
                        <h5 style={{ margin: "0px 0", fontWeight: "bold", color: categoryColors[item.key] }}>{item.name}</h5>
                        <h6 style={{ fontSize: "18px", fontWeight: "bold", color: "#1890ff" }}>{item.count}</h6>
                        {/* {item.details && item.details.map((detail, index) => (
                        <p key={index} style={{ fontSize: "14px", color: "#555" }}>{detail}</p>
                    ))} */}
                    </Card>
                ))}
            </div>
        );
    };



    const getLentryColorFormat = (formatList, featureAvatarMapList) => {
        // Sort by fixed order: Basic, Hard Wire/Solid Wire, Horizontal, Fronius, Lincoln
        const displayOrder = featureAvatarMapList === featureAvatarMap ? FEATURE_DISPLAY_ORDER_M500 : FEATURE_DISPLAY_ORDER_P625;
        const sortedList = [...(formatList || [])].sort((a, b) => {
            const idxA = displayOrder.indexOf(a);
            const idxB = displayOrder.indexOf(b);
            return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
        });
        return (
            <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: '10px', padding: '5px' }}>
                {sortedList.map((item, index) => {
                    const avatarData = featureAvatarMapList[item]; // Get the corresponding data

                    return (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <Tooltip title={avatarData.tooltip}>
                                <Avatar
                                    className="member-avatar"
                                    style={{
                                        backgroundColor: avatarData.color,
                                        color: avatarData.textColor,
                                        fontWeight: "bold",
                                        marginLeft: '2px',
                                        width: '29px',
                                        height: '29px',
                                    }}
                                >
                                    <span style={{ fontSize: '16px', fontWeight: 'bold', paddingBottom:'5px' }}>{avatarData.label.charAt(0)}</span>
                                                    <span style={{ fontSize: '10px', fontWeight: 'normal', marginLeft: '2px' }}>
                                                        {avatarData.Label_1}
                                                    </span>
                                </Avatar>
                            </Tooltip>
                            <div style={{ margin: 0, fontSize: '12px' }}>{avatarData.tooltip}</div>
                        </div>
                    );
                })}
            </div>
        );
    };



    return (
        // <div className="d-flex flex-column h-100">
        <div className="flex-auto">
            <div className="d-flex mb-3 align-items-center tab-content-title">


                <div className='back_equip' >
                    <Tooltip title={'Back'} >
                        <ArrowLeftOutlined onClick={() => {
                            history.push('/SmartLync-HomePage');
                        }} />
                    </Tooltip>
                </div>

                <Title className="mb-0 add-new-calibration" level={3} style={{ paddingLeft: '30px' }}>
                    License Manager
                </Title>


                <div className="new-calibration">
                    {/* {userGroup &&  userGroup.includes('license-manager-admin') &&
                        <>
                            <Text style={{ marginTop: '10px', fontSize: '15px', marginRight: '10px' }}> Perpetual </Text>
                            <DatePicker className='date-picker'
                                allowClear={true}
                                style={{ height: '35px', border: 'line', width: '25%', marginLeft: '0px' }}
                                format="DD-MM-YYYY"
                                placeholder='Select date'
                                onChange={(date, dateString) => handlePerpetualDateSelect(date, dateString)}
                                bordered={true}
                                disabledDate={
                                    current => !current
                                        || current < moment().subtract(1, "days")

                                        || current > moment('2128-01-01', 'YYYY-MM-DD')

                                }
                            />
                        </>
                    } */}



                    <Tooltip title="Share license">

                        {/* <Button size='large' onClick={() => onshowShareLicenseFrom()} className="ps-3 add-new-calibration" >
                            <ShareAltOutlined style={{ fontSize: '18px' }} />
                            Share License
                        </Button> */}


                        <Button shape="round" key="apply" type="primary" onClick={() => onshowShareLicenseFrom()} style={{ marginLeft: '10px' }}>
                            <ShareAltOutlined style={{ fontSize: '20px' }}> </ShareAltOutlined>  Share License
                        </Button>

                    </Tooltip>
                    <Text onClick={() => handleLicenseVisibe()} className="ps-3 add-new-calibration"   >
                        <span className="icon-22">
                            <svg>
                                <use xlinkHref="#add" />
                            </svg>
                        </span>
                        Manage License
                    </Text>
                </div>
            </div>
            <div className="custom-line" />
            {/* <div style={{ paddingTop: '20px' }}>

                <Row gutter={2} style={{ paddingTop: "0px", width: '100%' }} >
                    <Col lg={3}>
                        <div className="searchEquip">
                            <Input
                                placeholder='Search By User Identifier'
                                //placeholder={`Search By ${selectedSearchBy}`}
                                onChange={(e) => { handleSearchInputChange('License_File_Name', e.target.value) }}
                                allowClear
                                style={{ borderRadius: '5px' }}
                            />
                        </div>

                    </Col>
                    <Col lg={3}>
                        <div className="searchEquip">
                            <Input
                                placeholder='Search By Unique ID'
                                onChange={(e) => { handleSearchInputChange('Unique_Id', e.target.value) }}
                                allowClear
                                style={{ borderRadius: '5px' }}
                            />
                        </div>
                    </Col>
                    <Col lg={3}>
                        <div className="searchEquip">
                            <Input
                                //style={{ width: '190px' }}
                                placeholder='Search By Machine Type'
                                onChange={(e) => { handleSearchInputChange('Type_Of_Device', e.target.value) }}
                                allowClear
                                style={{ borderRadius: '5px' }}
                            />
                        </div>
                    </Col>
                    <Col lg={3}>
                        <div className="searchEquip">
                            <Input
                                //style={{ width: '190px' }}
                                placeholder='Search By Location'
                                onChange={(e) => { handleSearchInputChange('Location', e.target.value) }}
                                allowClear
                                style={{ borderRadius: '5px' }}
                            />
                        </div>
                    </Col>

                    <Col lg={3}>
                        <div className="searchEquip">
                            <Input
                                //style={{ width: '190px' }}
                                placeholder='Search By Customer'
                                onChange={(e) => { handleSearchInputChange('Customer', e.target.value) }}
                                allowClear
                                style={{ borderRadius: '5px' }}
                            />
                        </div>
                    </Col>
                    <Col lg={3}>
                        <div className="searchEquip">
                            <Input
                                //style={{ width: '190px' }}
                                placeholder='Search By Feature Type'
                                onChange={(e) => { handleSearchInputChange('Feature_Type', e.target.value) }}
                                allowClear
                                style={{ borderRadius: '5px' }}
                            />
                        </div>
                    </Col>

                    <Col lg={3}>

                        <div className='date-picker'>
                            <DatePicker
                                allowClear={true}
                                style={{ height: '28px', border: 'line', borderRadius: '5px' }}
                                format="DD-MM-YYYY"
                                placeholder='Search By Create Date'
                                onChange={(date, dateString) => { handleSearchInputChange('File_Creation_Date', moment(dateString).format('YYYY-MM-DD')) }}
                                bordered={true}
                            />
                        </div>
                    </Col>
                    <Col lg={3}>
                        <div className='date-picker'>
                            <DatePicker
                                allowClear={true}
                                style={{ height: '28px', border: 'line', borderRadius: '5px' }}
                                format="DD-MM-YYYY"
                                placeholder='Search By Expiration Date'

                                onChange={(date, dateString) => { handleSearchInputChange('Expiration_Date', moment(dateString).format('YYYY-MM-DD')) }}
                            />
                        </div>
                    </Col>
                </Row>
            </div> */}
            <div className='addTeamDetailsLicense'>
                <Table columns={columns}

                    className="h-100 pipeline-table equip_table equipPaginationTable licenseSort"
                    scroll={{ y: 'calc(100vh - 270px)' }}
                    // expandable={{
                    //     expandedRowRender,
                    //     className: 'h-100 pipeline-table equip_table equipPaginationTable',
                    //     expandIcon: ({ expanded, onExpand, record }) =>
                    //         expanded ? (
                    //             <DownCircleTwoTone twoToneColor={'transparent'} style={{ fontSize: '150%' }} onClick={(e) => onExpand(record, e)} />
                    //         ) : (
                    //             <RightCircleTwoTone twoToneColor={'transparent'} style={{ fontSize: '150%' }} onClick={(e) => onExpand(record, e)} />
                    //         ),
                    // }}
                    //rowClassName={rowClassName}
                    rowClassName={(record, index) => (index % 2 === 0 ? 'even-row' : 'odd-row')}
                    rowKey={'id'}
                    pagination={
                        licenseTotalCount > 10 ? {
                            position: ['bottomRight'],
                            className: 'fixed-pagination',
                            showSizeChanger: true,
                            total: licenseTotalCount,
                            defaultPageSize: 10,
                            defaultCurrent: 1,

                            onChange: async (pageNumber, pageSize) => {
                                // console.log(licenseTotalCount, pageNumber, pageSize)
                                setCurrentPageNumber(pageNumber);
                                setCurrentPagesize(pageSize);
                                var obj = {
                                    pageSize: pageSize,
                                    pageNumber: pageNumber,
                                    searchKey: searchCriteria,
                                    sort: sortingKeys
                                }
                                await onFetchLicenseData(obj)

                            }
                        }
                            : false
                    }
                    sortOrder={true}
                    onChange={async (pagination, filters, sorter) => {
                        if (sorter.columnKey && sorter.order) {
                            const sortOrder = sorter.order === 'descend' ? 'DESC' : 'ASC';
                            const sortParam = {
                                columnKey: sorter.columnKey,
                                sortOrder: sortOrder
                            };
                            setSortingKeys(sortParam)

                            var obj = {
                                pageSize: currentPagesize,
                                pageNumber: currentPageNumber,
                                searchKey: searchCriteria,
                                sort: sortParam
                            }
                            await onFetchLicenseData(obj)

                            // await onProjectList(obj)
                            //onFetchSparesDashBoardList(sortParam);
                        }
                    }}


                    dataSource={licenseData}
                    loading={isLicenseLoading}
                />
            </div>
            <div className='fixed-ColorFormate' style={{ paddingTop: '00px', display: 'flex', flexWrap: 'wrap', justifyContent: 'left', width: '70%' }} >
                {getLentryColorFormat(featurelegtatyAvatarMap, featureAvatarMap)}
                {getLentryColorFormat(featureP625LengtaryAvatarMap, featureP625AvatarMap)}
            </div>
            {
                generateLiceseVisible &&
                <GenerateLicenseForm
                    setGenerateLiceseVisible={setGenerateLiceseVisible}
                    generateLiceseVisible={generateLiceseVisible}
                    record={editRecord}
                    licenseForm={licenseForm}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    setPerpetualDate={setPerpetualDate}
                    perpetualDate={perpetualDate}
                    UpdateFilterCategory={UpdateFilterCategory}
                    fetchLicenseData={fetchLicenseData}
                />
            }
            <div>
                {
                    showShareModel && <ShareLicenseForm

                        setShowShareModel={setShowShareModel}
                        showShareModel={showShareModel}
                        shareForm={shareForm}
                        uniqueIdData={uniqueIdData}
                        setuniqueIdData={setuniqueIdData}
                        licenseUniqueIdList={licenseUniqueIdList}
                        setLicenseUniqueIdList={setLicenseUniqueIdList}
                    >

                    </ShareLicenseForm>
                }
            </div>
            <div>
                {
                    showDownloadModel && <DownloadForm

                        setShowDownloadModel={setShowDownloadModel}
                        showDownloadModel={showDownloadModel}
                        downloadDataList={downloadDataList}
                    >

                    </DownloadForm>
                }
            </div>

        </div >
        // </div>
    )
};
const mapStateToProps = ({ licenseMangerReducer }) => {
    const licenseData = get(licenseMangerReducer, 'LicenseData', []);
    const isLicenseLoading = get(licenseMangerReducer, 'isLicenseLoading', false);
    //const isUploadLicsense = get(licenseMangerReducer, 'isUploadLicsense', false);
    const licenseTotalCount = get(licenseMangerReducer, 'LicenseListCount', null);
    return {
        licenseData,
        isLicenseLoading,
        // isUploadLicsense,
        licenseTotalCount
    }
}

const mapDispatchToProps = {
    onFetchLicenseData: fetchGroupLicenseList,

}

export default connect(mapStateToProps, mapDispatchToProps)(GenerateLicense);
